import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginContext } from '../../../reactcontext/ReactContext'
import axios from 'axios'
import swal from 'sweetalert'
import PassportTable from './PassportTable'
import logo from '../../../assets/logo.avif'

export const MedicalEditModal = ({ selectedRow, onClose, onSaved }) => {
  const apiUrl = process.env.REACT_APP_API_URL
  const [formData, setFormData] = useState({
    id: selectedRow?.Employee?.Health?.id || '',
    employeeId: selectedRow?.Employee?.id || '',
    mcRefNo: selectedRow?.Employee?.Health?.mcRefNo || '',
    mcApprovalDate: selectedRow?.Employee?.Health?.mcApprovalDate ? selectedRow.Employee.Health.mcApprovalDate.split('T')[0] : '',
    mcValidUntil: selectedRow?.Employee?.Health?.mcValidUntil ? selectedRow.Employee.Health.mcValidUntil.split('T')[0] : '',
    mcWith: selectedRow?.Employee?.Health?.mcWith || '',
    mcStatus: selectedRow?.Employee?.Health?.mcStatus || '',
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setFormData({
      id: selectedRow?.Employee?.Health?.id || '',
      employeeId: selectedRow?.Employee?.id || '',
      mcRefNo: selectedRow?.Employee?.Health?.mcRefNo || '',
      mcApprovalDate: selectedRow?.Employee?.Health?.mcApprovalDate ? selectedRow.Employee.Health.mcApprovalDate.split('T')[0] : '',
      mcValidUntil: selectedRow?.Employee?.Health?.mcValidUntil ? selectedRow.Employee.Health.mcValidUntil.split('T')[0] : '',
      mcWith: selectedRow?.Employee?.Health?.mcWith || '',
      mcStatus: selectedRow?.Employee?.Health?.mcStatus || '',
    })
  }, [selectedRow])

  const saveMedical = () => {
    if (!formData.id && !formData.employeeId) {
      swal({ icon: 'error', title: 'Invalid data', text: 'No employee selected.' })
      return
    }

    setLoading(true)
    axios.put(`${apiUrl}/employee/updateHealthInfo`, formData, {
      headers: { loginToken: localStorage.getItem('loginToken') },
    })
      .then((result) => {
        setLoading(false)
        if (result.data.message) {
          swal({ icon: 'success', title: 'Saved', text: 'Medical record updated successfully.', buttons: false, timer: 1800 })
          onSaved()
          onClose()
        } else {
          swal({ icon: 'error', title: 'Error', text: result.data.error || 'Unable to save medical record.' })
        }
      })
      .catch((err) => {
        setLoading(false)
        swal({ icon: 'error', title: 'Error', text: err.response?.data?.error || err.message })
      })
  }

  if (!selectedRow) return null

  return (
    <div>
      <div className='fixed inset-0 bg-gray-700 opacity-60 z-40' onClick={onClose}></div>
      <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
        <div className='w-full max-w-2xl bg-white rounded-xl shadow-xl overflow-hidden'>
          <div className='flex items-center justify-between p-4 border-b'>
            <div>
              <h2 className='text-xl font-semibold'>Edit Medical Certificate</h2>
              <p className='text-sm text-gray-500'>Employee: {selectedRow.Employee?.firstName} {selectedRow.Employee?.lastName}</p>
              <p className='text-sm text-gray-500'>Passport: {selectedRow.passportNo}</p>
              <p className='text-sm text-gray-500'>Visa Expire Date: {(() => {
                const visas = selectedRow.Employee?.Visas
                if (!visas || visas.length === 0) return 'N/A'
                const latest = visas.reduce((a, b) => new Date(a.expiryDate) > new Date(b.expiryDate) ? a : b)
                return latest.expiryDate ? latest.expiryDate.split('T')[0] : 'N/A'
              })()}</p>
            </div>
            <button onClick={onClose} className='text-gray-500 hover:text-gray-800'>Close</button>
          </div>
          <div className='p-4 grid gap-4 md:grid-cols-2'>
            <div className='flex flex-col'>
              <label className='text-sm text-gray-700 mb-1'>MC Ref No</label>
              <input
                className='border border-gray-300 rounded px-3 py-2'
                value={formData.mcRefNo}
                onChange={(e) => setFormData({ ...formData, mcRefNo: e.target.value })}
              />
            </div>
            <div className='flex flex-col'>
              <label className='text-sm text-gray-700 mb-1'>Approval Date</label>
              <input
                type='date'
                className='border border-gray-300 rounded px-3 py-2'
                value={formData.mcApprovalDate}
                onChange={(e) => setFormData({ ...formData, mcApprovalDate: e.target.value })}
              />
            </div>
            <div className='flex flex-col'>
              <label className='text-sm text-gray-700 mb-1'>Valid Until</label>
              <input
                type='date'
                className='border border-gray-300 rounded px-3 py-2'
                value={formData.mcValidUntil}
                onChange={(e) => setFormData({ ...formData, mcValidUntil: e.target.value })}
              />
            </div>
            <div className='flex flex-col'>
              <label className='text-sm text-gray-700 mb-1'>MC With</label>
              <select
                className='border border-gray-300 rounded px-3 py-2'
                value={formData.mcWith}
                onChange={(e) => setFormData({ ...formData, mcWith: e.target.value })}
              >
                <option value=''>Select MC With</option>
                <option value='By Company'>By Company</option>
                <option value='Himself'>Himself</option>
              </select>
            </div>
            <div className='md:col-span-2 flex flex-col'>
              <label className='text-sm text-gray-700 mb-1'>Status</label>
              <select
                value={formData.mcStatus}
                onChange={(e) => setFormData({ ...formData, mcStatus: e.target.value })}
                className='border border-gray-300 rounded px-3 py-2'
              >
                <option value=''>Select status</option>
                <option value='Approved'>Approved</option>
                <option value='Pending'>Pending</option>
                <option value='Rejected'>Rejected</option>
                <option value='N/A'>N/A</option>
              </select>
            </div>
          </div>
          <div className='p-4 border-t flex justify-end gap-3'>
            <button
              onClick={onClose}
              className='px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100'
            >
              Cancel
            </button>
            <button
              onClick={saveMedical}
              className='px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700'
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const MedicalTableInit = () => {
  const apiUrl = process.env.REACT_APP_API_URL
  const [medicalRows, setMedicalRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedRow, setSelectedRow] = useState(null)
  const [statusFilter, setStatusFilter] = useState('All')
  const { loginInfo } = useContext(LoginContext)
  const navigate = useNavigate()

  const printedBy = loginInfo?.userDetails
    ? `${loginInfo.userDetails.firstName} ${loginInfo.userDetails.lastName}`
    : 'Admin'

  function getReadableTimestamp() {
    const now = new Date()
    return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`
  }

  const handleExportPDF = (data) => {
    if (!data || data.length === 0) return
    const html2pdf = require('html2pdf.js')
    const tdStyle = 'padding:4px 6px;border:1px solid #e5e7eb;'
    const rows = data.map((r, i) => `
      <tr style="background:${i % 2 === 0 ? '#fff' : '#f9fafb'}">
        <td style="${tdStyle}">${r.Employee ? `${r.Employee.firstName} ${r.Employee.lastName}` : 'N/A'}</td>
        <td style="${tdStyle}">${r.passportNo || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Health?.mcRefNo || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Health?.mcApprovalDate ? r.Employee.Health.mcApprovalDate.split('T')[0] : 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Health?.mcValidUntil ? r.Employee.Health.mcValidUntil.split('T')[0] : 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Health?.mcWith || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Health?.mcStatus || 'N/A'}</td>
        <td style="${tdStyle}">${(() => { const visas = r.Employee?.Visas; if (!visas || visas.length === 0) return 'N/A'; const latest = visas.reduce((a, b) => new Date(a.expiryDate) > new Date(b.expiryDate) ? a : b); return latest.expiryDate ? latest.expiryDate.split('T')[0] : 'N/A'; })()}</td>
      </tr>`).join('')
    const el = document.createElement('div')
    el.style.cssText = 'padding:20px;font-family:Arial,sans-serif;font-size:11px;'
    el.innerHTML = `
      <div style="text-align:center;margin-bottom:14px;">
        <img src="${logo}" style="width:60px;display:block;margin:0 auto 6px auto;" crossorigin="anonymous"/>
        <div style="font-size:16px;font-weight:bold;margin:4px 0;">Rahman Group</div>
        <div style="font-size:13px;margin:2px 0;">Report Listing - Medical List</div>
      </div>
      <div style="display:flex;gap:30px;flex-wrap:wrap;margin-bottom:12px;">
        <span><em>Printed By:</em> <strong>${printedBy}</strong></span>
        <span><em>Printed On:</em> <strong>${getReadableTimestamp()}</strong></span>
        <span><em>Total Records:</em> <strong>${data.length}</strong></span>
        <span><em>Signature:</em> <strong>______________</strong></span>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:10px;">
        <thead><tr style="background:#e5e7eb;">
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Employee Name</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Passport</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">MC Ref No</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Approval Date</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Valid Until</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">MC With</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Status</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Visa Expire Date</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`
    html2pdf().set({
      margin: 10,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    }).from(el).outputPdf('blob').then(blob => {
      window.open(URL.createObjectURL(blob), '_blank')
    })
  }

  useEffect(() => {
    if (!loginInfo.login) {
      navigate('/')
    }
  }, [loginInfo, navigate])

  const fetchMedicalRows = React.useCallback(async () => {
    setLoading(true)
    const loginToken = localStorage.getItem('loginToken')

    if (!loginToken) {
      console.log('No login token found in localStorage')
      setLoading(false)
      return
    }

    try {
      console.log('Fetching medical list from:', `${apiUrl}/employee/medicalList`)
      const res = await axios.get(`${apiUrl}/employee/medicalList`, {
        headers: { loginToken },
      })
      console.log('Medical list response:', res.data)
      if (res.data.error) {
        swal({ icon: 'error', title: 'Error', text: res.data.error })
        setMedicalRows([])
      } else {
        setMedicalRows(res.data.passports || [])
      }
    } catch (err) {
      console.error('Error fetching medical list:', err)
      console.error('Error response:', err.response)
      console.error('Error message:', err.message)
      const errorMsg = err.response?.data?.error || err.message || 'Network Error'
      swal({ icon: 'error', title: 'Error', text: errorMsg })
      setMedicalRows([])
    } finally {
      setLoading(false)
    }
  }, [apiUrl])

  useEffect(() => {
    fetchMedicalRows()
  }, [fetchMedicalRows])

  const columns = useMemo(
    () => [
      {
        Header: 'Employee Name',
        accessor: (row) =>
          row.Employee ? `${row.Employee.firstName} ${row.Employee.lastName}` : 'N/A',
      },
      {
        Header: 'Passport',
        accessor: (row) => row.passportNo || 'N/A',
      },
      {
        Header: 'MC Ref No',
        accessor: (row) => row.Employee?.Health?.mcRefNo || 'N/A',
      },
      {
        Header: 'Approval Date',
        accessor: (row) => row.Employee?.Health?.mcApprovalDate ? row.Employee.Health.mcApprovalDate.split('T')[0] : 'N/A',
      },
      {
        Header: 'Valid Until',
        accessor: (row) => row.Employee?.Health?.mcValidUntil ? row.Employee.Health.mcValidUntil.split('T')[0] : 'N/A',
      },
      {
        Header: 'MC With',
        accessor: (row) => row.Employee?.Health?.mcWith || 'N/A',
      },
      {
        Header: 'Status',
        accessor: (row) => row.Employee?.Health?.mcStatus || 'N/A',
      },
      {
        Header: 'Visa Expire Date',
        accessor: (row) => {
          const visas = row.Employee?.Visas
          if (!visas || visas.length === 0) return 'N/A'
          const latest = visas.reduce((a, b) => new Date(a.expiryDate) > new Date(b.expiryDate) ? a : b)
          return latest.expiryDate ? latest.expiryDate.split('T')[0] : 'N/A'
        },
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: ({ row }) => (
          <button
            className='px-3 py-1 rounded bg-blue-600 text-white text-sm hover:bg-blue-700'
            onClick={() => setSelectedRow(row.original)}
          >
            Edit
          </button>
        ),
      },
    ],
    []
  )

  const filteredRows = useMemo(() => {
    if (statusFilter === 'All') return medicalRows
    if (statusFilter === 'N/A') return medicalRows.filter(r => !r.Employee?.Health?.mcStatus)
    return medicalRows.filter(r => r.Employee?.Health?.mcStatus === statusFilter)
  }, [medicalRows, statusFilter])

  return (
    <div className='w-full h-full overflow-auto'>
      <MedicalEditModal
        selectedRow={selectedRow}
        onClose={() => setSelectedRow(null)}
        onSaved={fetchMedicalRows}
      />
      {loading ? (
        <p className='w-full h-full text-center text-lg py-5'>Fetching medical data... Please wait</p>
      ) : (
        <PassportTable
          columns={columns}
          data={filteredRows}
          onExportPDF={handleExportPDF}
          extraControls={
            <div className='flex items-center gap-1'>
              {['All', 'Approved', 'Pending', 'Rejected', 'N/A'].map(s => (
                <button
                  key={s}
                  onClick={() => setStatusFilter(s)}
                  className={`px-3 py-1.5 text-sm rounded-md font-medium border transition-colors ${
                    statusFilter === s
                      ? s === 'Approved' ? 'bg-green-500 text-white border-green-500'
                        : s === 'Pending' ? 'bg-yellow-400 text-white border-yellow-400'
                        : s === 'Rejected' ? 'bg-red-400 text-white border-red-400'
                        : 'bg-gray-700 text-white border-gray-700'
                      : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'
                  }`}
                >
                  {s}
                </button>
              ))}
            </div>
          }
        />
      )}
    </div>
  )
}

export default MedicalTableInit
